<!-- 页面已弃用 -->
<template> 
  <div v-loading="loadCurrent" class="cousreing_box">
    <div class="cousre_header">
      <slot name="cousreTitle" />(<em>10</em>/{{ courseCurrent.length }})
    </div>
    <div class="cousre_time">
      {{ $t('sync.data') }}：2019-5-10  12：24：03
    </div>
    <div class="course_prcess">
      <vuescroll>
        <div v-for="(item,index) in courseCurrent" :key="item.index" class="course_list">
          <div class="course_cont">
            <span class="prcess_index">{{ index + 1 }}.</span>
            <div class="course_card">
              <div class="course_left">
                <div class="card_badge">
                  <em>del</em>
                </div>
                <i class="icon-43" />
                <img src="../../assets/img/d_f1.png">
              </div>
              <div class="course_right">
                <p class="course_name">
                  {{ item.DeviceName }}
                </P>
                <p class="course_block">
                  {{ $t('sync.areaname') }}：{{ item.ParentAreaNames }}
                </P>
              </div>
            </div>
						
            <div class="course_state">
              <div v-show="item.ResultCode == 3" class="state_faile">
                <i class="icon-11" />
                <button @click="retry(item)">
                  {{ $t('sync.retry') }}
                </button>
              </div>
              <i v-show="item.ResultCode == 2||item.ResultCode==1" class="state_sucess icon-5" />  
              <span v-show="item.ResultCode == 0" class="type">{{ $t('sync.synchronizing') }}</span>
            </div>
          </div>
        </div>
      </vuescroll>
    </div>
    <button class="curse_go" @click="backgroundDoCurrent">
      {{ $t('sync.background') }}
    </button>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import { ShowCurrentSyncResult,ReSyncAreaCode } from '@/axios/IArea.js';
import { ShowSceneCurrentSyncResult } from '@/axios/IScene.js';
import { ShowIftttCurrentSyncResult } from '@/axios/IFttt.js';
export default {
	name: 'Course', //removecurrent：设备集合  areaTreeType：查询的类型
	components: {
		vuescroll
	},
	 props:['removecurrent','areaTreeType'],
	data() {
		return {
			loadCurrent:false,  //是否显示加载
			courseCurrent:[], //数据
			
		};
	},
	mounted(){
		//查询数据
		this.doShowCurrentSyncResult();
	},
	methods: {
		/* 查询看板数据返回的数据处理
		* rs：返回的原始数据包
		*/
		functionDoShowCurrentSyncResult(rs){
			if (rs.StatusCode == this.$store.state.rightStatusCode) {
				this.courseCurrent=rs.Result;
			}
			this.loadCurrent=false;
		},
		/* 查询看板数据 包括 设备1 场景2 自动化3 根据不同参数
		*/
		doShowCurrentSyncResult(){
			this.courseCurrent=[];
			this.loadCurrent=true;
			if(this.areaTreeType==1){
				//设备
				ShowCurrentSyncResult(this.removecurrent,this.functionDoShowCurrentSyncResult);
			}else if(this.areaTreeType==2){
				//场景
				ShowSceneCurrentSyncResult(this.removecurrent,this.functionDoShowCurrentSyncResult);
			}else if(this.areaTreeType==3){
				//自动化
				ShowIftttCurrentSyncResult(this.removecurrent,this.functionDoShowCurrentSyncResult);
			}
			
		},
		/* 查询设备的同步状态 接口返回数据处理
		* rs：返回的原始数据包
		*/
		functionDoReSyncAreaCode(rs){
			if (rs.StatusCode == this.$store.state.rightStatusCode) {
				this.doShowCurrentSyncResult();
			}
		},
		/* 查询设备的同步状态
		* item：设备对象
		*/
		doReSyncAreaCode(item){
			var para={gpNo:item.GpNo,vDeviceId:item.VDeviceId,channelId:item.ChannelId};
			ReSyncAreaCode(para,this.functionDoReSyncAreaCode);
			para=null;
		},
		/* 点击重试
		* item：设备对象
		*/
		retry(item){
			this.doReSyncAreaCode(item);
			//this.$emit('retry',item);
		},
		/* 点击后台执行 直接让调用页面处理
		*/
		backgroundDoCurrent(){
			 this.$emit('backgroundDoCurrent');
		}
		
		
	}
};
</script>

<style lang="scss" scoped>
	/* 进程面板组件 */
.cousre_header{
	color: #202020;
	em{
		font-style: normal;
	   color: #4f8ee7;	
	}
}
.curse_go {
    
    background-color: $color5;
  
    border: solid 1px $color5;
  
}
</style>
